module.exports = __webpack_public_path__ + "static/media/shoe-care-service.2fc24708.png";